module.exports = __webpack_public_path__ + "static/media/omaope.c4679826.JPG";